import { jsx } from 'react/jsx-runtime';
import { createContext } from 'react';

const defaultValues = {
    size: 'sm',
    loading: false,
    fallback: '--'
};
const NumberBoxContext = /*#__PURE__*/ createContext(defaultValues);
const NumberBoxProvider = ({ children, ...values })=>{
    return jsx(NumberBoxContext.Provider, {
        value: {
            ...defaultValues,
            ...values
        },
        children: children
    });
};
NumberBoxProvider.displayName = 'NumberBox.Provider';

export { NumberBoxContext, NumberBoxProvider };
//# sourceMappingURL=NumberBox.Context.es.js.map
